<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar>
          <dropdown :disabled="noClamping" :class="['mx-2']" v-model="lineClamp" :items="lineClamps" width="150px" :ripple-color="$dark ? 'white' : 'gray'" :ripple-color-lightness="$dark ? null : 300" :color="$root.$colors.primary" :color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" v-model="noClamping" :label="$lang.noClamping" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" />
        </test-toolbar>
      </flex-col>
      <flex-col :span="24">
        <multiline-ellipsis @click.native="noClamping = !noClamping" v-html="text" :title="$lang.clickToExpandCollapse" :class="['text-xs', 'cursor-pointer']" :line-clamp="noClamping ? null : lineClamp[0]" />
      </flex-col>
    </flex>
    <lorem-ipsum ref="lorem-ipsum" hidden />
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PageMultilineEllipsis',
  mixins: [
    methods
  ],
  data () {
    return {
      text: null,
      noClamping: false,
      lineClamp: [3],
      lineClamps: Array.from(Array(5).keys()).map(value => {
        value = value + 1
        return {
          value,
          text: this.$lang.clampAt(value)
        }
      })
    }
  },
  mounted () {
    this.getLoremIpsumRawContent()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ui/multiline-ellipsis.vue